<template>
  <v-row justify="center" >
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card  class="custom-modal">
        <div class="px-4 pt-3">
          <div class="d-flex align-center header-modal">
            <div class="mr-2">
              <v-img width="40" height="40" src="@/assets/images/modals/icon-success.jpg" />
            </div>
            <div class="font-weight-bold line-liff-detail">{{title}}</div>
          </div>
          <div class="pt-2 pb-0 px-3 text-grey3">
            {{body}}
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" class="btn-close font-weight-bold" text @click="confirm()">
            {{btnOk}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    name: 'ModalFail',
    data: function () {
        return {
            btnOk: null,
            title: null,
            body: null,
            dialog: false
        }
    },
    methods: {
        show: function (lang) {
            const { title, btnOk, body } = lang
            this.title = title
            this.btnOk = btnOk
            this.body = body || '..'
            this.dialog = true
        },
        hide: function () {
            this.title = null
            this.btnOk = null
            this.body = null
            this.dialog = false
        },
        confirm: function () {
            this.hide()
            const params = {}
            this.$emit('clickOk', params)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/color.scss";

.header-modal {
  font-size: 18px;
  color: $base-grey3;
}
.btn-close {
  color: $base-orange;
}
</style>
